import { useState } from "react";
import { ArrowUpRight, Plus } from "@phosphor-icons/react";
import { experience } from "../data/experience";
import s from "./Experience.module.css";

export default function Experience() {
  const [open, setOpen] = useState(0);

  return (
    <section id="experience" className={`section ${s.experience}`} aria-labelledby="experience-title" tabIndex={-1}>
      <div className="container">
        <h2 id="experience-title" className="section-title">
          Experience
        </h2>

        <ol className={s.list}>
          {experience.map((role, i) => {
            const isOpen = open === i;
            const id = `role-${i}`;
            return (
              <li key={`${role.company}-${role.start}`} className={`${s.item} ${isOpen ? s.open : ""}`}>
                <h3 className={s.heading}>
                  <button
                    type="button"
                    className={s.trigger}
                    aria-expanded={isOpen}
                    aria-controls={`${id}-panel`}
                    id={`${id}-trigger`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                  >
                    <span className={s.dates}>
                      {role.start} - {role.end}
                    </span>
                    <span className={s.title}>{role.title}</span>
                    <span className={s.company}>{role.company}</span>
                    <span className={s.icon} aria-hidden="true">
                      <Plus size={20} weight="bold" />
                    </span>
                  </button>
                </h3>

                {/* Grid-row collapse: content stays in the DOM, no height measuring. */}
                <div
                  id={`${id}-panel`}
                  role="region"
                  aria-labelledby={`${id}-trigger`}
                  className={s.panel}
                  // @ts-expect-error inert is valid HTML, missing from this React version's types
                  inert={isOpen ? undefined : ""}
                >
                  <div className={s.panelInner}>
                    <div className={s.body}>
                      <p className={s.summary}>{role.summary}</p>
                      <ul className={s.bullets}>
                        {role.bullets.map((b) => (
                          <li key={b}>{b}</li>
                        ))}
                      </ul>
                      <ul className="tag-list" aria-label="Technologies">
                        {role.stack.map((t) => (
                          <li key={t} className="tag">
                            {t}
                          </li>
                        ))}
                      </ul>
                      <p className={s.where}>
                        {role.location}
                        {role.companyUrl && (
                          <a href={role.companyUrl} target="_blank" rel="noreferrer" className={s.companyLink}>
                            Company site
                            <ArrowUpRight size={15} weight="bold" aria-hidden="true" />
                          </a>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
